/**
 * @file Use ROQ locale hook
 */

import { Locale } from '../../generated/graphql';
import useLocale from '../../hooks/useLocale';
import { getLanguageCode } from '../../utils/user/language';

/**
 * All locale languages that we support, in format for ROQ chat.
 */
export type ROQLocale = 'de-DE' | 'en-US' | 'fr-FR' | 'it-IT' | 'nl-NL';

/**
 * Map our locale language codes to ROQ codes.
 */
const localeMap: Record<Locale, ROQLocale> = {
  [Locale.de]: 'de-DE',
  [Locale.en]: 'en-US',
  [Locale.fr]: 'fr-FR',
  [Locale.it]: 'it-IT',
  [Locale.nl]: 'nl-NL',
};

/**
 * Use ROQ locale hook
 *
 * @returns The locale formatted for ROQ chat
 */
export const useRoqLocale = (): ROQLocale => {
  const language = useLocale() ?? getLanguageCode();

  return localeMap[language];
};
